import {
  VacanciesTemplatesForm,
  type VacanciesTemplatesFormValues,
} from '../vacanciesTemplatesForm';
import { useNavigate } from 'react-router';
import { useCreateVacancyTemplate } from '@entities/vacancy';
import { QueryKey } from '@shared/config';
import { useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@shared/utils';
import { getTagsByGroupsForCreate } from '@shared/helpers';
import { useGetSkill } from '@entities/skill';

export const VacanciesTemplatesCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate: createVacancyTemplate, isPending } =
    useCreateVacancyTemplate();
  const { data: skills } = useGetSkill();

  const handleBackClick = () => {
    navigate('/vacancies-templates-list');
  };

  const handleSubmit = (values: VacanciesTemplatesFormValues) => {
    createVacancyTemplate(
      {
        ...values,
        currencyId: Number(values.currencyId),
        salaryFrom: Number(values.salaryFrom),
        salaryTo: Number(values.salaryTo),
        paymentPeriodId: Number(values.paymentPeriodId),
        employmentTypeIds: values.employmentTypeIds?.map(Number),
        scheduleWorkIds: values.scheduleWorkIds?.map(Number),
        skills: getTagsByGroupsForCreate({
          directory: skills || [],
          selectedDirectory: values.skills,
        }),
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [QueryKey.GET_VACANCIES_TEMPLATES],
          });

          queryClient.invalidateQueries({
            queryKey: [QueryKey.GET_SKILLS],
          });

          navigate('/vacancies-templates-list');
        },
        onError: error => {
          showNotification({
            error,
            variant: 'error',
            message:
              error.response?.data.message || 'Ошибка при создании шаблона',
          });
        },
      }
    );
  };

  return (
    <VacanciesTemplatesForm
      onBackHandler={handleBackClick}
      onSubmit={handleSubmit}
      loading={isPending}
      disabled={isPending}
    />
  );
};
